import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_SEARCH_ADDRESS;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
